/* Nous rencontrer : tri des tuiles, compte à rebours, bascule jour J.
   Les tuiles sont rendues côté Liquid (métaobjets evenement) avec
   data-debut / data-fin en ISO 8601 ; ici on ne touche qu'aux chiffres
   et aux attributs hidden. Une tuile passe en « On y est ! » entre
   début et fin, puis disparaît ; sans événement à venir, l'état vide
   s'affiche. */
(function () {
  'use strict';

  var liste = document.getElementById('rv-liste');
  var vide = document.getElementById('rv-vide');
  if (!liste) return;

  /* ---- tri chronologique (l'ordre de création des métaobjets est
     quelconque ; data-debut/data-fin sont des timestamps epoch en
     secondes, posés par Liquid avec date: '%s') ---- */
  var tuiles = Array.prototype.slice.call(liste.querySelectorAll('.rv-tuile'));
  tuiles.sort(function (a, b) {
    return a.getAttribute('data-debut') - b.getAttribute('data-debut');
  });
  tuiles.forEach(function (t) {
    liste.appendChild(t);
  });

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* ---- tick : décompte, bascule jour J, disparition, badge « prochain » ---- */
  function tick() {
    var now = Date.now();
    var prochainMarque = false;
    var visibles = 0;

    tuiles.forEach(function (t) {
      var debut = t.getAttribute('data-debut') * 1000;
      var fin = t.getAttribute('data-fin') * 1000;

      if (now >= fin) {
        t.hidden = true;
        return;
      }
      visibles++;

      var enCours = now >= debut;
      t.querySelector('.rv-compte').hidden = enCours;
      t.querySelector('.rv-live').hidden = !enCours;

      /* le premier événement pas terminé porte le badge et le halo */
      var proche = !prochainMarque;
      prochainMarque = true;
      t.classList.toggle('proche', proche);
      /* pendant l'événement, « On y est ! » suffit : pas de double badge */
      t.querySelector('.rv-badge').hidden = !proche || enCours;

      if (!enCours) {
        var d = debut - now;
        var vals = {
          jours: Math.floor(d / 86400000),
          heures: pad(Math.floor(d / 3600000) % 24),
          minutes: pad(Math.floor(d / 60000) % 60),
          secondes: pad(Math.floor(d / 1000) % 60)
        };
        t.querySelectorAll('.rv-n').forEach(function (el) {
          el.textContent = vals[el.getAttribute('data-u')];
        });
      }
    });

    if (vide) vide.hidden = visibles > 0;
  }

  tick();
  setInterval(tick, 1000);
})();
